export const foodAvailable = {
    "14623": [
        {
            "name": "Wegman's Marketplace",
            "address": "650 Hylan Drive",
            "town": "Rochester",
            "state": "New York",
            "zip": "14623",
            "date": "03/06/2022",
            "timestart": "5:00 PM",
            "timeend": "8:00 PM",
            "food": "Apples, bananas, cucumbers, pizza"
        },
        {
            "name": "McDonald's",
            "address": "45 Jay Scutti Blvd",
            "town": "Rochester",
            "state": "New York",
            "zip": "14623",
            "date": "03/06/2022",
            "timestart": "9:00 PM",
            "timeend": "11:00 PM",
            "food": "Burgers, fries, milkshakes"
        },
        {
            "name": "TGI Friday's",
            "address": "125 White Spruce Blvd",
            "town": "Rochester",
            "state": "New York",
            "zip": "14623",
            "date": "03/06/2022",
            "timestart": "7:00 PM",
            "timeend": "11:00 PM",
            "food": "Burgers, chicken, steak, chips"
        },
        {
            "name": "Gracie's",
            "address": "Grace Watson Hall, Greenleaf Ct",
            "town": "Rochester",
            "state": "New York",
            "zip": "14623",
            "date": "03/06/2022",
            "timestart": "7:00 PM",
            "timeend": "11:00 PM",
            "food": "Nothing edible"
        },
        {
            "name": "Bean's",
            "address": "Grace Watson Hall, Greenleaf Ct",
            "town": "Rochester",
            "state": "New York",
            "zip": "14623",
            "date": "03/08/2022",
            "timestart": "7:00 PM",
            "timeend": "8:00 PM",
            "food": "Baked goods such as elephant ears, danishes, muffins, and smoothies!"
        }
    ]
}